import { CheckIcon } from '@heroicons/react/solid';
import DropDownMenu, {
  DropDownMenuRefType,
} from 'components/elements/dropDownMenu';
import { usePlpStore } from 'components/modules/plp/DataStore';
import useOwnRouter from 'lib/hooks/useOwnRouter';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';
import { useUrlFactory } from 'lib/hooks/useUrlFactory';
import { observer } from 'mobx-react';
import { useRef } from 'react';

function TopMainContnt() {
  const { t } = useOwnTranslate();
  const dropDown = useRef<DropDownMenuRefType>(null);

  const sortList: Record<string, { label: string; listingType: string[] }> = {
    trueCheck_desc: {
      label: "تصدیق شده",
      listingType: ["BUY", "RENT"],
    },
    searchDate_desc: {
      label: t('plp.sorting.date.desc'),
      listingType: ["BUY", "RENT"],
    },
    floorArea_desc: {
      label: t('plp.sorting.floorArea.desc'),
      listingType: ["BUY", "RENT"],
    },
    floorArea_asc: {
      label: t('plp.sorting.floorArea.asc'),
      listingType: ["BUY", "RENT"],
    },
    priceOrDeposit_desc: {
      label: t('plp.sorting.price.desc'),
      listingType: ["BUY"],
    },
    priceOrDeposit_asc: {
      label: t('plp.sorting.price.asc'),
      listingType: ["BUY"],
    },
  };
  const urlFactory = useUrlFactory();
  const router = useOwnRouter();

  const {
    seoResult,
    sort: selectedSort,
    setSort,
    setPage,
    filterData
  } = usePlpStore();

  const setSelectedSort = (sort: string) => {
    setSort(sort);
    setPage(0);


    dropDown.current?.toggleMenuOpen();
    urlFactory.modify('sort', sort);
    urlFactory.modify('page', 0);

    router.push(`/${urlFactory.fullPathname}`, '', { shallow: true });
  };
  const listingType = filterData
    ? filterData.listingType
    : urlFactory?.pathParams
      ? urlFactory?.pathParams?.listingTypeStr?.toUpperCase()
      : "";

  const validListingType = typeof listingType === 'string' ? listingType : '';
  // eslint-disable-next-line no-prototype-builtins
  const sortSelected = sortList.hasOwnProperty((selectedSort.split(','))[0])?(selectedSort.split(','))[0]:"trueCheck_desc";
  return (
    <>
      <div className="flex mx-auto my-4">
        <h1 className="flex justify-start flex-1 my-3 text-sm md:text-lg text-grey-500">
          {seoResult?.title}
        </h1>
        <div className="items-center justify-end flex-1 flex">
          <DropDownMenu
            lable={sortList[sortSelected].label}
            ref={dropDown}
            className="h-10 w-fit"
          >
            <div className="w-fit">
              <ul className="w-48 text-sm font-medium bg-white rounded-md text-grey-900 max-h-[225px]">
                {Object.keys(sortList).map(
                  (sort) =>
                    sortList[sort].listingType.includes(validListingType) && (
                      <li
                        key={sort}
                        className="flex flex-row justify-between p-2 cursor-pointer hover:bg-primary-25"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setSelectedSort(sort);
                        }}
                      >
                        <span>{sortList[sort].label}</span>
                        {sortSelected === sort && (
                          <CheckIcon className="w-4 h-4 text-primary-700" />
                        )}
                      </li>
                    )
                )}
              </ul>
            </div>
          </DropDownMenu>
        </div>
      </div>
    </>
  );
}

export default observer(TopMainContnt);
